/**
 * Created by smizrahi on 8/1/16.
 */

import Logger from "../../utils/Logger";
import Persistence from "../../persistence/Persistence";
import Config from "../config/Config";

const CONFIG_KEY = 'EQCONFIG';
const CONFIG_NEXT_CHECK_KEY = 'EQCONFIG_NEXT_CHECK';
const CONFIG_COUPON = 'EQCONFIG_COUPON';
const CONFIG_VERSION = 'EQCONFIG_VERSION';

export default class ConfigPersist extends Persistence {

    constructor() {
        super();
    }

    /**
     * Save a configuration into local storage
     *
     * @param config
     */
    saveConfig(config, version) {
        this.set(CONFIG_KEY, JSON.stringify(config));
        this.set(CONFIG_VERSION, version);
    }

    /**
     * Get the configuration from local storage
     *
     * @returns {*} A configuration
     */
    loadConfig() {
        Logger.log("Loading config from cache :");
        let c = this.get(CONFIG_KEY);
        if (c) {
            let config = Config.restore(JSON.parse(c));
            Logger.log(config);
            return config;

        } else {
            Logger.log("No config in cache");
        }
    }

    /**
     * Get the configuration web service version of persisted config
     *
     * @returns {Number} The configuration web service version
     */
    loadVersion() {
        let v = this.get(CONFIG_VERSION);
        if (v) {
            return parseInt(v);
        }

        return null;
    }

    /**
     * Save the timestamp where configuration should be next checked into local storage
     *
     * @param timestamp
     */
    saveNextCheckDate(timestamp) {
        this.set(CONFIG_NEXT_CHECK_KEY, timestamp);
    }

    /**
     * Get the timestamp where configuration should be next checked
     *
     * @returns {Number} The next check config timestamp
     */
    loadNextCheckDate() {
        let c = this.get(CONFIG_NEXT_CHECK_KEY);
        if (c) {
            return parseInt(JSON.parse(c));

        } else {
            Logger.log("No config next check date in cache");
        }

    }

    /**
     * Save the last coupon used to update config (can be null)
     *
     * @param {string|null} coupon the coupon to save
     */
    saveCoupon(coupon) {
        this.set(CONFIG_COUPON, coupon);
    }

    /**
     * Get the last coupon used to update config
     *
     * @returns {string|null} the last coupon used, can be null
     */
    loadCoupon() {
        let c = this.get(CONFIG_COUPON);
        if (c) {
            return c;
        } else {
            Logger.log("No coupon in cache");
        }

    }

    /**
     * Delete configuration informations
     */
    clearConfigurationData() {
        this.delete(CONFIG_KEY);
        this.delete(CONFIG_NEXT_CHECK_KEY);
        this.delete(CONFIG_VERSION);
    }

}


// WEBPACK FOOTER //
// ./js/core/configuration/persistence/ConfigPersist.js